/* eslint-disable @typescript-eslint/naming-convention */
import { SegmentSchema } from '@sondermind/segment';
import { USER_TYPE } from './common.interface';

export interface ISummarizationConsentEventData {
  user_type: USER_TYPE;
  persona_id: number;
  dialog_shown: boolean;
  error?: unknown;
  abtesting?: string;
}

export enum SummarizationConsentEvents {
  SUMMARIZATION_CONSENT_SHOWN = 'Summarization Consent Shown',
  SUMMARIZATION_CONSENT_OPTIN = 'Summarization Consent Opt In',
  SUMMARIZATION_CONSENT_OPTOUT = 'Summarization Consent Opt Out',
  SUMMARIZATION_NOT_SHOWN_DEVICE = 'Summarization Consent Not Shown Device',
  SUMMARIZATION_NOTE_SHOWN_AGE = 'Summarization Consent Not Shown Age',

}

export interface ISummarizationConsentSchema extends SegmentSchema {
  [SummarizationConsentEvents.SUMMARIZATION_CONSENT_SHOWN]: ISummarizationConsentEventData;
  [SummarizationConsentEvents.SUMMARIZATION_CONSENT_OPTIN]: ISummarizationConsentEventData;
  [SummarizationConsentEvents.SUMMARIZATION_CONSENT_OPTOUT]: ISummarizationConsentEventData;
  [SummarizationConsentEvents.SUMMARIZATION_NOT_SHOWN_DEVICE]: ISummarizationConsentEventData;
  [SummarizationConsentEvents.SUMMARIZATION_NOTE_SHOWN_AGE]: ISummarizationConsentEventData;
}
